import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { LikeCommentMutation, LikeCommentMutationVariables } from './likeComment.graphql';
import { LikeComment } from './likeComment.graphql';

export type LikeCommentInput = LikeCommentMutationVariables['input'];
export type LikeCommentResponse = Pick<LikeCommentMutation['likeComment'], 'success' | 'liked'>;

export async function likeComment(
	{ gql: { fetch } }: UtilityContext,
	{ commentId, like }: LikeCommentInput,
): Promise<LikeCommentResponse> {
	const { data } = await fetch<LikeCommentMutation, LikeCommentMutationVariables>({
		query: LikeComment,
		variables: {
			input: {
				commentId,
				like,
			},
		},
		rejectOnError: true,
	});

	if (!data.likeComment.success) throw new Error(`Unable to like comment (${data.likeComment.reason || 'unknown'})`);

	return data.likeComment;
}
